import {gql} from "@apollo/client";

export const GET_NEXT_ACTION_LIST = gql`
  query DeliveryQuery {
    getNextActionList {
      name
      value
    }
  }
`;

export interface NextActionListResponse {
    getNextActionList: NextActionListType[];
}

export interface NextActionListType {
    name: string;
    value: number;
}